import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { projectGridStyles } from './project-grid.css';
import { renderProjectGridPresentation, type ProjectGridProps } from './project-grid-presentation';
import { MarkdownDoc } from '../../data/markdownEngine';

@customElement('project-grid')
export class ProjectGrid extends LitElement {
  static styles = [projectGridStyles];

  @property({ type: Array }) projects: MarkdownDoc[] = [];

  private openDoc(doc: MarkdownDoc) {
    this.dispatchEvent(
      new CustomEvent('open-doc', {
        detail: { doc },
        bubbles: true,
        composed: true,
      })
    );
  }

  render() {
    const props: ProjectGridProps = {
      projects: this.projects,
      onOpenDoc: (doc: MarkdownDoc) => this.openDoc(doc),
    };

    return renderProjectGridPresentation(props);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'project-grid': ProjectGrid;
  }
}
